<svg xmlns="http://www.w3.org/2000/svg" width="19" height="52" viewBox="0 0 19 52">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square" stroke-width="1.5">
        <path fill="#FFF" d="M14.2 35.76V5.8a4.8 4.8 0 0 0-9.6 0v29.96A8.52 8.52 0 0 0 1 42.6a8.4 8.4 0 0 0 16.8 0 8.192 8.192 0 0 0-3.6-6.84z"/>
        <path d="M5.5 12.5h3M5.5 18.5h3M5.5 24.5h3M5.5 30.5h3"/>
    </g>
</svg>
